import React, { useState, useEffect, createContext, useContext } from 'react'
import useIsMounted from '~hooks/useIsMounted'

const EthersContext = createContext({})

export const useEthers = () => (
    useContext(EthersContext)
)

async function getEthers() {
    try {
        const { Contract, getDefaultProvider, providers } = await import(
            /* webpackExports: ["Contract", "getDefaultProvider", "providers"] */
            'ethers'
        )

        return [{
            Contract,
            getDefaultProvider,
            providers,
        }, null]
    } catch (e) {
        return [null, e]
    }
}

async function getMetamaskProvider() {
    try {
        const { default: detect } = await import(
            /* webpackExports: ["default"] */
            '@metamask/detect-provider'
        )

        const metamaskProvider = await detect()

        return [metamaskProvider, null]
    } catch (e) {
        return [null, e]
    }
}

export default function EthersProvider({ children }) {
    const [lib, setLib] = useState({})

    const isMounted = useIsMounted()

    useEffect(() => {
        (async () => {
            const [ethers] = await getEthers()

            const [metamaskProvider] = await getMetamaskProvider()

            if (!isMounted()) {
                return
            }

            setLib({
                ...ethers,
                metamaskProvider,
            })
        })()
    }, [isMounted])

    return (
        <EthersContext.Provider value={lib}>
            {children}
        </EthersContext.Provider>
    )
}
